export default __webpack_public_path__ + "static/media/news-icon.125d5a26.svg";